'use strict';

var React = require('react');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
/**
 * @author mengxiaojiang
 * @createData 2016-6-14
 * @descriptor 水平分隔条
 */
var HorizontalSplitter = React.createClass({
  render : function(){
    return (<div className="component component-HorizontalSplitter">
      <ul style={{paddingLeft:(styleHelper.getWidth(this.props) - 14)/2}}>
        <li/>
        <li/>
        <li/>
      </ul>

    </div>);
  }
});

module.exports = HorizontalSplitter;



/** WEBPACK FOOTER **
 ** ./src/views/Components/HorizontalSplitter.jsx
 **/